import { render, staticRenderFns } from "./SPRPage.vue?vue&type=template&id=a2373800&scoped=true&"
import script from "./SPRPage.vue?vue&type=script&lang=js&"
export * from "./SPRPage.vue?vue&type=script&lang=js&"
import style0 from "./SPRPage.vue?vue&type=style&index=0&id=a2373800&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2373800",
  null
  
)

export default component.exports